// extracted by mini-css-extract-plugin
export default {"component":"ToggleSwitchPanel_component__F8oSl","darkMode":"ToggleSwitchPanel_darkMode__zPlSD","lightOnDark":"ToggleSwitchPanel_lightOnDark__NM4VN"};